import { render, staticRenderFns } from "./form.vue?vue&type=template&id=21fab332&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yoreirei/Documents/project/other/market-ui/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21fab332')) {
      api.createRecord('21fab332', component.options)
    } else {
      api.reload('21fab332', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=21fab332&", function () {
      api.rerender('21fab332', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/form/src/form.vue"
export default component.exports